import API from '@/models/API';

export default class Store {
  constructor(item = {}) {
    this.store_id = item.store_id || 53;
    this.store_subscription_plan_id = item.store_subscription_plan_id || null;
    this.country_id = item.country_id || null;
    this.name = item.name || '';
    this.store_code = item.store_code || '';
    this.app_name = item.app_name || '';
    this.address = item.address || '';
    this.zip = item.zip || null;
    this.lat = item.lat || null;
    this.lon = item.lon || null;
    this.vat_number = item.vat_number || null;
    this.email = item.email || '';
    this.primary_phone = item.primary_phone || null;
    this.parent_id = item.parent_id || 1;
    this.store_company_network_region_id = item.store_company_network_region_id || null;
    this.bank_providers = item.bank_providers || [];
    this.registration_date = item.registration_date || '';
    this.manually_address = item.manually_address || false;
    this.coupon_claim_valid_days = Number(item.coupon_claim_valid_days) || 25;
    this.flags = item.flags;
  }

  static getSubscriptionPlans = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/subscription-plans`);

  static getCountries = () => API.get(`/common/countries`);

  static getNetworkRegions = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/network-regions?page=1`);

  static get = (query) => API.get(`/companies/${localStorage.getItem('storeId')}/stores${query}`);

  static getFinancialData = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/stores/summaries${query}`);

  static create = (item) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/stores/create`, item);

  static update = (item, id) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/stores/${id}`, item);

  static toggleStoreValue = (id, payload) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/stores/${id}/app-settings`, payload);

  static delete = (id) => API.delete(`/companies/${localStorage.getItem('storeId')}/stores/${id}`);

  static getStoresDefaultPermissions = () => API.get(`/users/default-permissions`);

  static getStorePermissions = (store_id) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/stores/${store_id}/permissions`);

  static updateDefaultPermissions = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/stores/default-cms-permissions`, body);

  static updateStorePermissions = (body, store_id) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/stores/${store_id}/permissions`, body);
}
